/**
 * List of resources that can be used in the permissions system.
 *
 * @description
 * - Though difficult in our current setup, we should aim to have resources be
 *   separated from roles (e.g. `ContractorPayments`, `AdminSettings`, etc.)
 * - Resources should span a granular feature that a user may access through the frontend/backed, frontend, or just backend.
 */
export const EPermissionResources = {
  AccrualBalances: "company.accrual_balances",
  AccrualPolicies: "company.accrual_policies",
  CompanySettings: "company.settings",
  CompanyName: "company.name",
  CompanyMembers: "company.members",
  ContractorPayments: "contractor.payments",
  Contractors: "company.contractors",
  /**
   * Name is specific on purpose as we're only defining this resource for guests to generate the ID scan links
   * Please update to a more generic name instead of adding a new one for another section
   */
  ContractorIDScanLinks: "contractor.id_scan_links",
  ContractorSettings: "contractor.settings",
  CustomAttributes: "company.custom.attributes",
  Departments: "company.departments",
  Deductions: "company.payroll.deductions",
  DirectPayments: "direct.payments",
  Employees: "company.employees",
  EmployeeChecks: "employee.checks",
  /**
   * Name is specific on purpose as we're only defining this resource for guests to generate the ID scan links
   * Please update to a more generic name instead of adding a new one for another section
   */
  EmployeeIDScanLinks: "employee.id_scan_links",
  EmployeeSettings: "employee.settings",
  InternalTools: "internal.tools",
  InviteMembers: "invitemembers",
  Jobs: "company.jobs",
  Locations: "company.locations",
  Onboarding: "company.onboarding",
  PartnerAPI: "partner.api",
  PartnerCompanies: "partner.companies",
  PartnerMembership: "partner.membership",
  PartnerSettings: "partner.settings",
  Paycards: "paycards",
  PaycardSSNVerificationHistory: "paycard.ssn.verification.history",
  PaycardStatements: "paycard.statements",
  PaycardTransactions: "paycard.transactions",
  PaymentItems: "contractor.payment_items",
  Payroll: "company.payroll",
  Reports: "company.reports",
  ServiceTypes: "company.service_types",
  ShareableLinks: "employee.shareable_links",
  Shifts: "company.payroll.shifts",
  Taxes: "company.taxes",
} as const;

export type EPermissionResources =
  (typeof EPermissionResources)[keyof typeof EPermissionResources];
